import { render, staticRenderFns } from "./KazangBanner.vue?vue&type=template&id=9d8d07f2&scoped=true"
import script from "./KazangBanner.vue?vue&type=script&lang=js"
export * from "./KazangBanner.vue?vue&type=script&lang=js"
import style0 from "./KazangBanner.vue?vue&type=style&index=0&id=9d8d07f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8d07f2",
  null
  
)

export default component.exports